import {
  PRIMARY_STACK_CLASS_NAME,
  SUMMARY_PREVIEW_INFO_LIST_STACK_CLASS_NAME,
  SUMMARY_PREVIEW_INFO_ITEM_STACK_CLASS_NAME,
} from '../../constants/stack';
import FingoMuiStack from '../../fingo/components/MuiStack';

const SUMMARY_PREVIEW_ITEMS_GAP = 24;
// Titulo y valor se superponen un poco en el diseño, para que el contenido mida 53px.
const SUMMARY_PREVIEW_TEXT_OVERLAP = -3;

const summaryPreviewContainer = ({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
});

const summaryPreviewContainerDesktop = () => ({
  padding: '20px 24px',
  borderRadius: '12px',
  minHeight: 'unset',
});

const summaryPreviewInfoDesktop = () => ({
  [`& .${SUMMARY_PREVIEW_INFO_LIST_STACK_CLASS_NAME} > :not(style) + :not(style)`]: {
    marginLeft: SUMMARY_PREVIEW_ITEMS_GAP,
  },
  [`& .${SUMMARY_PREVIEW_INFO_ITEM_STACK_CLASS_NAME} > :not(style) + :not(style)`]: {
    marginTop: SUMMARY_PREVIEW_TEXT_OVERLAP,
  },
  [`& .${SUMMARY_PREVIEW_INFO_ITEM_STACK_CLASS_NAME} > .MuiTypography-root:first-child`]: {
    lineHeight: '24px',
  },
  [`& .${SUMMARY_PREVIEW_INFO_ITEM_STACK_CLASS_NAME} > .MuiTypography-root:last-child`]: {
    fontSize: 24,
    // El archivo Display "semibold" (600) se ve mas grueso que el semibold del diseño;
    // el diseño corresponde al archivo "bold" (700).
    fontWeight: 700,
    lineHeight: '32px',
  },
});

const primaryStack = ({ theme }) => ({
  ...summaryPreviewContainer({ theme }),
  [theme.breakpoints.up('md')]: {
    ...summaryPreviewContainerDesktop(),
    ...summaryPreviewInfoDesktop(),
  },
});

const MuiStack = {
  ...FingoMuiStack,
  styleOverrides: {
    ...FingoMuiStack.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiStack.styleOverrides.root({ theme }),
      [`&.${PRIMARY_STACK_CLASS_NAME}`]: primaryStack({ theme }),
    }),
  },
};

export default MuiStack;
